<template>
  <div class="budget-bid-wrap">
    <div class="card-header">
      预算与出价<span class="num-text">{{ dataList.length }}/10</span>
      <div class="btn-group">
        <el-button icon="el-icon-plus" type="text" @click="newBudgetbid">新建</el-button><span class="center-line"></span>
        <el-button icon="el-icon-plus" type="text" @click="selectBudgetBid">选择已有</el-button>
      </div>
    </div>
    <div class="card-list">
      <card-item
        v-for="(item, index) of dataList"
        :key="item.itemId"
        :dataSet="item"
        :title="'新建预算包' + (index + 1)"
        @edit="editBudget"
        @copy="copyBudget"
        @del="delBudget"
        :isCur="curFormData.itemId === item.itemId"
        :showDelete="dataList.length > 1"
      ></card-item>
    </div>
    <div class="modal-body">
      <ul class="modal-form">
        <el-form :model="curFormData" :rules="rules" ref="formRef">
          <li class="form-item">
            <span class="form-label">投放场景：</span>
            <div class="form-value">
              <el-radio-group v-model="curFormData.smart_bid_type">
                <el-radio v-for="item in smart_bid_type_list" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item" v-show="curFormData.smart_bid_type === 'SMART_BID_CUSTOM'">
            <span class="form-label">竞价策略：</span>
            <div class="form-value">
              <el-radio-group v-model="curFormData.flow_price" @change="changeFlowprice">
                <el-radio label="stableCost">稳定成本</el-radio>
                <el-radio label="controlCost" :disabled="showDeep">控制成本上限</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item" v-show="curFormData.smart_bid_type === 'SMART_BID_CUSTOM'">
            <span class="form-label">投放速度：</span>
            <div class="form-value">
              <el-radio-group v-model="curFormData.speed">
                <el-radio label="constantSpeed">匀速</el-radio>
                <el-radio label="accelerate" :disabled="curFormData.flow_price === 'controlCost'">加速</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item" style="margin-bottom: 0px">
            <span class="form-label" style="padding-top: 6px">预算：</span>
            <div class="form-value">
              <el-form-item prop="budget">
                <el-input style="width: 264px" placeholder="> 300" v-model.trim="curFormData.budget">
                  <template slot="prepend">
                    <div class="down-wrap">
                      <el-dropdown size="small" trigger="click" @command="checkBudgetMode">
                        <span class="el-dropdown-link">
                          <span>{{ curFormData.budget_mode === "BUDGET_MODE_DAY" ? "日预算" : "总预算" }}</span
                          ><i class="el-icon-arrow-down" style="margin-left: 4px"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="BUDGET_MODE_DAY">日预算</el-dropdown-item>
                          <el-dropdown-item command="BUDGET_MODE_TOTAL">总预算</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </template>
                  <template slot="append">CNY</template>
                </el-input>
              </el-form-item>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label">投放时间：</span>
            <div class="form-value">
              <el-radio-group v-model="curFormData.schedule_type">
                <el-radio label="SCHEDULE_FROM_NOW">从今天到长期投放</el-radio>
                <el-radio label="SCHEDULE_START_END">设置开始和结束日期</el-radio>
              </el-radio-group>
              <div v-show="curFormData.schedule_type === 'SCHEDULE_START_END'">
                <el-date-picker
                  class="data-range"
                  v-model="curFormData.selectDate"
                  type="daterange"
                  range-separator="→"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm"
                  style="width: 265px"
                  :clearable="false"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </div>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label">投放时间段：</span>
            <div class="form-value">
              <el-radio-group v-model="curFormData.schedule_time">
                <el-radio label="0">不限</el-radio>
                <el-radio label="1">指定时间段</el-radio>
              </el-radio-group>
              <div class="time-range-wrap" v-show="curFormData.schedule_time === '1'">
                <time-table ref="timeTableRef"></time-table>
              </div>
            </div>
          </li>
          <li class="form-item" v-show="curFormData.smart_bid_type === 'SMART_BID_CUSTOM'">
            <span class="form-label">付费方式：</span>
            <div class="form-value">
              <el-radio-group v-model="curFormData.pricing">
                <el-radio label="OCPM">按展示付费(oCPM)</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item" v-show="curFormData.smart_bid_type !== 'SMART_BID_NO_BID'">
            <span class="form-label">出价模式：</span>
            <div class="form-value">
              <el-radio-group v-model="curFormData.bid_mode">
                <el-radio label="fixed">固定出价</el-radio>
                <el-radio label="ladder">阶梯出价</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item" v-if="curFormData.bid_mode === 'ladder'">
            <span class="form-label">出价范围：</span>
            <div class="form-value">
              <el-form-item prop="min_bid">
                <el-input style="width: 164px" v-model="curFormData.min_bid" placeholder="最低价">
                  <template slot="append">CNY</template>
                </el-input>
                <span style="margin: 0 20px">—</span>
                <el-input style="width: 164px" v-model="curFormData.max_bid" placeholder="最高价">
                  <template slot="append">CNY</template>
                </el-input>
              </el-form-item>

              <div class="form-value" style="margin-top: 12px">
                <el-radio-group v-model="curFormData.bid_type">
                  <el-radio label="random">随机出价</el-radio>
                  <el-radio label="fixed">固定步长</el-radio>
                </el-radio-group>
              </div>
              <span style="margin-top: 8px; font-size: 12px; color: #999"
                >最终会取最高值与最低值后，再根据单次批量创建的计划数计算并平均分配出价</span
              >
            </div>
          </li>
          <li
            v-show="curFormData.smart_bid_type !== 'SMART_BID_NO_BID' && curFormData.bid_mode !== 'ladder'"
            class="form-item"
            style="margin-bottom: 0px"
          >
            <span class="form-label" style="padding-top: 6px">目标转化出价：</span>
            <div class="form-value">
              <el-form-item prop="cpa_bid">
                <el-input style="width: 264px" v-model.trim="curFormData.cpa_bid">
                  <template slot="append">CNY</template>
                </el-input>
                <span style="color: #338aff; margin-left: 6px; cursor: pointer" @click="viewSuggestBid">点击查看建议出价</span>
              </el-form-item>
            </div>
          </li>
          <li v-show="showDeep" class="form-item">
            <span class="form-label">深度优化方式：</span>
            <div class="form-value">
              <el-radio-group v-model="curFormData.deep_bid_type">
                <el-radio label="DEEP_BID_PACING">自动优化</el-radio>
                <el-radio label="DEEP_BID_MIN">自定义双出价</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item" v-show="showDeep && curFormData.deep_bid_type === 'DEEP_BID_MIN'">
            <span class="form-label">深度出价模式：</span>
            <div class="form-value">
              <el-radio-group value="custom">
                <el-radio label="custom">固定出价</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item" v-show="showDeep && curFormData.deep_bid_type === 'DEEP_BID_MIN'">
            <span class="form-label" style="padding-top: 6px">深度转化出价：</span>
            <div class="form-value">
              <el-input style="width: 264px" v-model="curFormData.deep_cpabid">
                <template slot="append">CNY</template>
              </el-input>
              <div v-if="curFormData.deep_cpabid" style="font-size: 14px; color: #666">
                按两个出价计算得到期望的目标深度转化率为{{
                  curFormData.deep_cpabid && (curFormData.cpa_bid / curFormData.deep_cpabid) * 100
                    ? ((curFormData.cpa_bid / curFormData.deep_cpabid) * 100).toFixed(2)
                    : "-"
                }}%
              </div>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label" style="padding-top: 6px">预算包名称：</span>
            <div class="form-value">
              <el-form-item prop="name">
                <el-input style="width: 264px" v-model="curFormData.name"></el-input>
              </el-form-item>
            </div>
          </li>
        </el-form>
      </ul>
      <span slot="footer" class="footer-wrap">
        <el-button type="primary" @click="confirmForm">保存到预算包</el-button>
      </span>
    </div>

    <checked-modal
      title="选择预算包"
      :tableConf="tableConf"
      rowKey="id"
      ref="checkedModalRef"
      @selectOk="selectOk"
      :apiName="getBudget"
    ></checked-modal>
    <el-dialog title="建议出价" :close-on-click-modal="false" :visible.sync="dialogVisible" width="700px">
      <div class="suggest-bid-content">
        <div>根据您近7天的素材质量评估结果中，建议出价如下：</div>
        <div style="display: flex; margin-top: 24px">
          <div class="first plan">
            <div class="price">
              <span style="font-size: 30px; font-weight: 600">{{ suggestBidData.bid_high_90 }}</span
              >元
            </div>
            <el-button type="primary" style="width: 80px; margin: 20px 0" @click="adoptBid(suggestBidData.bid_high_90)">采纳</el-button>
            <div class="chart"></div>
            <div class="tip">竞争力超过<span style="color: #3389fe">90%</span>的计划</div>
            <div class="tip">展示量级较大</div>
          </div>
          <div class="second plan">
            <div class="price">
              <span style="font-size: 30px; font-weight: 600">{{ suggestBidData.bid_high_50 }}</span
              >元
            </div>
            <el-button type="primary" style="width: 80px; margin: 20px 0" @click="adoptBid(suggestBidData.bid_high_50)">采纳</el-button>
            <div class="chart"></div>
            <div class="tip">竞争力超过<span style="color: #3389fe">50%</span>的计划</div>
            <div class="tip">展示量级适中</div>
          </div>
          <div class="third plan">
            <div class="price">
              <span style="font-size: 30px; font-weight: 600">{{ suggestBidData.suggested_bid }}</span
              >元
            </div>
            <el-button disabled style="width: 80px; margin: 20px 0; background: #f8f9f9">不建议</el-button>
            <div class="chart"></div>
            <div class="tip">竞争力较弱</div>
            <div class="tip">展示量级较小</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>
  </div>
</template>

<script>
import TimeTable from "@/components/timeTable.vue";
import CardItem from "./common/cardItem.vue";
import { mapState } from "vuex";
import CheckedModal from "./common/checkedModal.vue";
import { newBudget, getBidSuggest, getBudget } from "@/api/promotion.js";
import { smart_bid_type_list } from "./subDirectpkg/optionData";
export default {
  components: {
    TimeTable,
    CardItem,
    CheckedModal,
  },
  data() {
    return {
      smart_bid_type_list,
      tableConf: [
        { title: "预算包名称", colName: "name" },
        { title: "创建时间", colName: "date" },
      ],
      getBudget,
      dialogVisible: false,
      isShowSuggestBid: false,
      suggestBidData: {
        bid_high_90: 0,
        bid_high_50: 0,
        suggested_bid: 0,
      },
      tableData: [],
      dataList: [],
      curFormData: {},
      rules: {
        cpa_bid: [
          {
            trigger: ["blur"],
            validator: (rule, value, callback) => {
              if (!value && this.curFormData.smart_bid_type !== "SMART_BID_NO_BID" && !this.isShowSuggestBid) {
                callback(new Error("请输入目标转化出价"));
              } else {
                callback();
              }
            },
          },
        ],
        budget: [
          {
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("请输入预算"));
              } else if (!/^[0-9]*$/.test(value) || Number(value) < 300) {
                callback(new Error("请输入不小于300的数字"));
              } else {
                callback();
              }
            },
            trigger: ["blur"],
          },
        ],
        min_bid: [
          {
            validator: (rule, value, callback) => {
              if (!this.curFormData.max_bid || !value) {
                callback(new Error("最低价和最高价不能为空"));
              } else if (
                !/^[+-]?(\d|([1-9]\d+))(\.\d+)?$/.test(this.curFormData.max_bid) ||
                !/^[+-]?(\d|([1-9]\d+))(\.\d+)?$/.test(value) ||
                Number(value) > Number(this.curFormData.max_bid)
              ) {
                callback(new Error("最低价和最高价为数字,且最低价不大于最高价"));
              } else {
                callback();
              }
            },
            trigger: ["blur"],
          },
        ],
        name: [
          {
            required: true,
            message: `预算包名称必填`,
            trigger: ["blur"],
          },
        ],
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 3600 * 24 * 1000;
        },
      },
    };
  },
  mounted() {
    this.newBudgetbid();
  },
  methods: {
    confirmForm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          //保存分段日期数据
          if (this.curFormData.schedule_time === "0") {
            this.curFormData.schedule_time_value = "";
          } else {
            this.curFormData.schedule_time_value = this.$refs.timeTableRef.checkedValue.join("");
          }
          let copyData = JSON.parse(JSON.stringify(this.curFormData));
          this.formatData(copyData);
          newBudget({
            data: JSON.stringify(copyData),
            advertiserId: this.adCount[0].advertiserId,
          }).then((res) => {
            if (res.code === "0000") {
              this.$message({
                message: "预算包新建成功",
                type: "success",
              });
              // this.saveCurData();
            }
          });
        } else {
          return false;
        }
      });
    },
    checkBudgetMode(budget_mode) {
      this.curFormData.budget_mode = budget_mode;
    },
    newBudgetbid() {
      if (this.dataList.length >= 10) {
        return;
      }
      let newItem = {
        itemId: Math.random(),
        name: "预算包" + (this.dataList.length + 1),
        smart_bid_type: "SMART_BID_CUSTOM",
        flow_price: "stableCost",
        speed: "accelerate",
        budget_mode: "BUDGET_MODE_DAY",
        budget: null,
        schedule_type: "SCHEDULE_FROM_NOW",
        selectDate: [], //接口为start_time end_time
        schedule_time: "0", //投放时间段 0不限 1指定时间段
        schedule_time_value: "",
        pricing: "OCPM",
        bid_mode: "fixed",
        min_bid: null,
        max_bid: null,
        bid_type: "fixed",
        cpa_bid: null, //目标转化出价
        deep_bid_type: "DEEP_BID_PACING", //深度优化方式（基础设置的深度转化目标设置之后必传！！！）
        deep_cpabid: null,
      };
      this.dataList.push(newItem);
      this.editBudget(newItem);
      this.saveListInStore();
    },
    selectBudgetBid() {
      this.$refs.checkedModalRef.showModal();
    },
    editBudget(dataItem) {
      //该数据不是接口格式！！！！！！
      this.saveCurData();
      this.curFormData = dataItem;
      if (dataItem.schedule_time === "1") {
        this.$refs.timeTableRef.showSelectNode(dataItem.schedule_time_value.split("").map((item) => Number(item)));
      } else {
        this.$refs.timeTableRef && this.$refs.timeTableRef.clearSelect();
      }
    },
    copyBudget(dataItem) {
      if (this.dataList.length >= 10) {
        return;
      }
      let copyData = JSON.parse(JSON.stringify(dataItem));
      copyData.itemId = Math.random();
      copyData.name = copyData.name + "_复制";
      this.dataList.push(copyData);
      this.saveListInStore();
    },
    delBudget(dataItem) {
      let curIndex = this.dataList.findIndex((item) => item.itemId === dataItem.itemId);
      this.dataList.splice(curIndex, 1);
      this.saveListInStore();
    },
    //格式化单条表单数据
    formatData(storeData) {
      storeData.budget === "" && (storeData.budget = null);
      storeData.cpa_bid === "" && (storeData.cpa_bid = null);
      storeData.deep_cpabid === "" && (storeData.deep_cpabid = null);
      // delete storeData.itemId;
      // delete storeData.name;
      //投放时间
      if (storeData.schedule_type === "SCHEDULE_START_END") {
        storeData.start_time = storeData.selectDate[0];
        storeData.end_time = storeData.selectDate[1];
      }
      delete storeData.selectDate;
      //投放时间段
      if (storeData.schedule_time === "0") {
        let str = "1";
        for (let i = 0; i < 48 * 7 - 1; i++) {
          str += "1";
        }
        storeData.schedule_time = str;
      } else {
        storeData.schedule_time = storeData.schedule_time_value;
      }
      delete storeData.schedule_time_value;

      //深度相关
      if (this.showDeep) {
        if (storeData.deep_bid_type === "DEEP_BID_PACING") {
          delete storeData.deep_cpabid;
        }
      } else {
        storeData.deep_bid_type = "DEEP_BID_DEFAULT";
        delete storeData.deep_cpabid;
      }
    },
    transforApiToForm(item) {
      item.itemId = item.itemId || Math.random();
      //投放时间
      if (item.schedule_type === "SCHEDULE_START_END") {
        item.selectDate = [item.start_time, item.end_time];
      } else {
        item.selectDate = [];
      }
      //投放时间段
      let str = "1";
      for (let i = 0; i < 48 * 7 - 1; i++) {
        str += "1";
      }
      item.schedule_time_value = item.schedule_time;
      if (item.schedule_time === str) {
        item.schedule_time = "0";
      } else {
        item.schedule_time = "1";
      }
      //深度相关
      item.deep_bid_type = item.deep_bid_type === "DEEP_BID_DEFAULT" ? "DEEP_BID_PACING" : item.deep_bid_type;
      item.deep_cpabid = item.deep_cpabid ? item.deep_cpabid : "";
      if (!item.bid_mode) {
        item.bid_mode = "fixed";
      }
      if (!item.bid_type) {
        item.bid_type = "fixed";
      }
      if (!item.min_bid) {
        item.min_bid = null;
      }
      if (!item.max_bid) {
        item.max_bid = null;
      }
    },
    changeFlowprice(val) {
      // 竞价策略为"控制成本上限"时，投放速度只可选择"加速"
      if (val === "controlCost") {
        this.curFormData.speed = "constantSpeed";
      }
    },
    saveCurData() {
      //保存分段日期数据
      if (this.curFormData.schedule_time === "0") {
        this.curFormData.schedule_time_value = "";
      } else {
        this.curFormData.schedule_time_value = this.$refs.timeTableRef.checkedValue.join("");
      }
      this.$refs.timeTableRef.clearSelect();
    },
    saveListInStore() {
      //保存到store
      let storeDataList = JSON.parse(JSON.stringify(this.dataList));
      storeDataList.forEach((storeData) => {
        this.formatData(storeData);
      });
      this.$store.commit("set_budget_and_bid", storeDataList);
    },
    selectOk(data) {
      let dataList = data.map((item) => {
        let formData = JSON.parse(item.data);
        this.transforApiToForm(formData);
        return formData;
      });
      this.dataList.push(...dataList);
      //保存到store
      let storeDataList = JSON.parse(JSON.stringify(this.dataList));
      storeDataList.forEach((storeData) => {
        this.formatData(storeData);
      });
      this.$store.commit("set_budget_and_bid", storeDataList);
    },
    //保存模板时不校验，直接保存
    saveData() {
      this.saveCurData(); //保存当前数据后再保存到store
      this.saveListInStore();
    },
    checkData(isSuggest = false) {
      return new Promise((resolve, reject) => {
        if (this.dataList.length > 0) {
          let pass = true;
          for (let i = 0; i < this.dataList.length; i++) {
            let item = this.dataList[i];
            if (
              (!item.cpa_bid && item.bid_mode !== "ladder" && item.smart_bid_type !== "SMART_BID_NO_BID" && !isSuggest) ||
              !item.budget ||
              !item.name
            ) {
              pass = false;
              this.editBudget(item);
              this.$nextTick(() => {
                this.$refs.formRef.validate(() => {});
              });
              break;
            }
          }
          if (pass) {
            this.saveData();
            resolve();
          } else {
            reject();
          }
        } else {
          reject();
        }
      });
    },
    getSuggestBidData() {
      getBidSuggest({
        advertiserId: this.adCount[0].advertiserId,
        audience: this.draft_adset.currentSelectedAudience?.data,
        budgetAndBid: this.draft_adset.budget_and_bid.find((item) => item.itemId === this.curFormData.itemId),
        targeting: this.draft_adset.targeting.find((item) => item.itemId === this.draft_adset.currentSelectedTargetingId),
      }).then((res) => {
        this.suggestBidData = res.data;
      });
    },
    // 查看建议出价
    viewSuggestBid() {
      this.isShowSuggestBid = true;
      this.$parent
        .checkSuggestBid()
        .then(() => {
          this.checkData(true)
            .then(() => {
              if (this.adCount.length > 0) {
                this.getSuggestBidData();
                this.dialogVisible = true;
                this.isShowSuggestBid = false;
              } else {
                this.isShowSuggestBid = false;
                this.$message.warning("请选择广告账户，即可查看建议出价");
              }
            })
            .catch(() => {
              this.isShowSuggestBid = false;
              this.$message.warning("请将预算与出价数据填写完整(目标转化出价除外)，即可查看建议出价");
            });
        })
        .catch(() => {
          this.isShowSuggestBid = false;
          this.$message.warning("请将定向包数据填写完整，即可查看建议出价");
        });
    },
    // 采纳
    adoptBid(value) {
      this.dialogVisible = false;
      this.curFormData.cpa_bid = value;
    },
  },
  computed: {
    ...mapState({
      //是否展示深度相关表单（是否设置了深度转化目标）
      showDeep: (state) => {
        let pro_obj = state.Promotion.draft_adset.promote_object;
        return pro_obj && pro_obj.deep_external_action !== "NONE" ? true : false;
      },
      budget_and_bid: (state) => state.Promotion.draft_adset.budget_and_bid,
      adCount: (state) => state.Promotion.adCount,
      draft_adset: (state) => state.Promotion.draft_adset,
    }),
  },
  watch: {
    budget_and_bid(value) {
      if (value) {
        let copyList = JSON.parse(JSON.stringify(value));
        //还原表格数据
        copyList.forEach((item) => {
          this.transforApiToForm(item);
        });
        this.dataList = copyList;
        if (this.dataList.length > 0) {
          //聚焦最后一个
          this.editBudget(this.dataList[this.dataList.length - 1]);
        }
      }
    },
    showDeep(value) {
      //深度优化目标不为"无"时,不可设置投放场景-最大转化投放、竞价策略-控制成本上限
      if (value) {
        if (this.curFormData.smart_bid_type === "SMART_BID_NO_BID") {
          this.curFormData.smart_bid_type = "SMART_BID_CUSTOM";
        }
        if (this.curFormData.flow_price === "controlCost") {
          this.curFormData.flow_price = "stableCost";
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.budget-bid-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    .num-text {
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      font-weight: normal;
      margin-left: 12px;
      position: relative;
      top: 2px;
    }
  }
  .btn-group {
    margin-left: auto;
    .center-line {
      border-left: 1px solid rgba(0, 0, 0, 0.25);
      margin: 0 20px;
    }
  }
  .modal-body {
    padding-top: 10px;
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 16px;
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 100px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(24, 144, 255, 1);
          }
          /deep/ .el-input-group__append,
          /deep/ .el-input-group__prepend {
            background-color: #fff;
            color: rgba(0, 0, 0, 0.85);
            padding: 0 10px;
          }
          .down-wrap {
            cursor: pointer;
          }
          .data-range {
            margin-top: 10px;
            position: relative;
            /deep/.el-range__icon {
              position: absolute;
              right: 6px;
              top: 0px;
            }
            /deep/.el-range-separator {
              line-height: 24px;
              color: rgba(0, 0, 0, 0.25);
            }
          }
          .time-range-wrap {
            margin-top: 10px;
            border: 1px solid #eee;
            padding-bottom: 14px;
          }
        }
      }
    }
    .footer-wrap {
      display: block;
      text-align: right;
    }
  }
  .card-list {
    display: flex;
    flex-wrap: wrap;
    padding-top: 16px;
  }
}
.suggest-bid-content {
  .plan {
    text-align: center;
    margin-right: 20px;
    .price {
      color: #3389fe;
      font-size: 20px;
    }
    .chart {
      margin-top: 5px;
      width: 200px;
      height: 40px;
      background: #cbf6f8;
      border-bottom: 4px solid #93edef;
      margin-bottom: 20px;
    }
    .tip {
      color: #c9c9c9;
      line-height: 24px;
    }
  }
  .second {
    .chart {
      margin-top: 20px;
      height: 25px;
      background: #d3e7ff;
      border-bottom: 4px solid #88bbff;
    }
  }
  .third {
    .price {
      color: #9d9c9d;
    }
    .chart {
      margin-top: 35px;
      height: 10px;
      background: #f1f1f1;
      border-bottom: 4px solid #d9d9d9;
    }
  }
}
</style>
